
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asia/ranking/[franchiseSlug]",
      function () {
        return require("private-next-pages/asia/ranking/[franchiseSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asia/ranking/[franchiseSlug]"])
      });
    }
  